import { useState } from "react";
import { Gift, Truck } from "lucide-react";

const STATUSES = ["in attesa di pagamento", "pagato", "in preparazione", "spedito", "consegnato", "annullato"];
const CARRIERS = ["", "GLS", "BRT", "DHL", "UPS", "SDA", "Altro"];

const TrackingEditor = ({ order, onSave }) => {
  const [carrier, setCarrier] = useState(order.tracking_carrier || "");
  const [num, setNum] = useState(order.tracking_number || "");
  const dirty = carrier !== (order.tracking_carrier || "") || num !== (order.tracking_number || "");
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2" data-testid={`admin-tracking-${order.id}`}>
      <Truck className="w-4 h-4 text-[#78716C]" />
      <select
        data-testid={`admin-tracking-carrier-${order.id}`}
        value={carrier}
        onChange={(e) => setCarrier(e.target.value)}
        className="rounded-full border border-[#E7E0D8] px-3 py-1.5 text-xs bg-white"
      >
        {CARRIERS.map((c) => <option key={c} value={c}>{c || "Corriere"}</option>)}
      </select>
      <input
        data-testid={`admin-tracking-number-${order.id}`}
        value={num}
        onChange={(e) => setNum(e.target.value)}
        placeholder="N. tracking spedizione"
        maxLength={60}
        className="rounded-full border border-[#E7E0D8] px-4 py-1.5 text-xs w-48"
      />
      {dirty && (
        <button data-testid={`admin-tracking-save-${order.id}`} onClick={() => onSave(order.id, carrier, num)} className="btn-tuscan px-4 py-1.5 rounded-full text-xs font-semibold">
          Salva tracking
        </button>
      )}
      {!dirty && num && <span className="text-xs text-[#3C6E53] font-semibold">✓ salvato</span>}
    </div>
  );
};

export const AdminOrdersTab = ({ orders, onUpdateStatus, onSaveTracking }) => (
  <div className="space-y-4">
    {orders.length === 0 && <p data-testid="admin-no-orders" className="text-[#78716C]">Nessun ordine ancora.</p>}
    {orders.map((o) => (
      <div key={o.id} data-testid={`admin-order-${o.id}`} className="rounded-2xl border border-[#E7E0D8] bg-white p-6">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div>
            <p className="font-mono-accent text-xs text-[#78716C]">#{o.id.slice(0, 8)} — {new Date(o.created_at).toLocaleString("it-IT")}
              {o.b2b && <span className="ml-2 rounded-full bg-[#2E8A57] text-white px-2.5 py-0.5 text-[10px] font-bold">B2B −{o.b2b_discount}% · {o.b2b_company}</span>}
            </p>
            <p className="font-semibold mt-1">{o.customer.name} · {o.customer.email}</p>
            <p className="text-sm text-[#78716C]">{o.customer.address}, {o.customer.cap} {o.customer.city} {o.customer.province}</p>
            {o.customer.delivery_date && (
              <p data-testid={`admin-order-delivery-${o.id}`} className="text-sm font-semibold text-[#3C6E53] mt-0.5">Consegna richiesta: {new Date(o.customer.delivery_date).toLocaleDateString("it-IT")}</p>
            )}
            {o.customer.gift && (
              <div data-testid={`admin-order-gift-${o.id}`} className="mt-2 rounded-xl bg-[#FBF6EC] border border-[#E9DFC8] px-4 py-2.5">
                <p className="text-sm font-semibold text-[#B4831A] inline-flex items-center gap-1.5">
                  <Gift className="w-4 h-4" /> Regalo{o.customer.gift_from ? ` da parte di ${o.customer.gift_from}` : ""}
                </p>
                {o.customer.gift_message && <p className="text-sm text-[#57534E] italic mt-1">"{o.customer.gift_message}"</p>}
              </div>
            )}
          </div>
          <div className="text-right">
            <p className="font-serif-display font-bold text-xl">{o.total.toFixed(2).replace(".", ",")} €</p>
            <select
              data-testid={`admin-order-status-${o.id}`}
              value={o.status}
              onChange={(e) => onUpdateStatus(o.id, e.target.value)}
              className="mt-2 rounded-full border border-[#E7E0D8] px-3 py-1.5 text-xs bg-white"
            >
              {STATUSES.map((s) => <option key={s}>{s}</option>)}
            </select>
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-[#E7E0D8] flex flex-wrap gap-x-6 gap-y-1 text-sm text-[#44403C]">
          {o.items.map((i) => <span key={i.slug}>{i.name} × {i.quantity}</span>)}
        </div>
        {o.payment_status === "paid" && <TrackingEditor order={o} onSave={onSaveTracking} />}
      </div>
    ))}
  </div>
);
